<script>
	export let data;
	export let noNeedToChange = false;

	import { isNewDataChanged } from "../../../../stores/variables";
	import { tooltip } from "../../../../scripts/tooltip";
	import { phoneMask } from "../../../../scripts/phone_mask";

	if (data) {
		if (!data.newData) data.newData = [];

		if (data.newData) {
			data.inputs.forEach((input) => {
				input.value = data.newData[input.field_name];
			});
		}
	}

	function phoneInputHandler(input, value) {
		data.newData[input.field_name] = phoneMask(value);
	}
</script>

{#if data.name}
	<h3>{data.name}</h3>
{/if}

{#if data}
	<div class="inputs">
		{#if data.inputs}
			{#each data.inputs as input, i}
				<div class="inputs__item">
					{#if input.type == "text"}
						<div
							class="inputs__input input__wrap input__wrap-comment"
						>
							<input
								type="text"
								required={input.required ? "required" : ""}
								title={input.description}
								bind:value={data.newData[input.field_name]}
								on:input={(e) => {
									if (!noNeedToChange)
										$isNewDataChanged = true;
									e.target.classList.remove("invalid");
								}}
								maxlength={input.maxlength
									? input.maxlength
									: 100}
							/>

							<span
								class={data.newData[input.field_name]
									? "active"
									: ""}>{input.description}</span
							>
						</div>
					{:else if input.type == "phone"}
						<div
							class="inputs__input input__wrap input__wrap-comment"
						>
							<input
								type="tel"
								required={input.required ? "required" : ""}
								title={input.description}
								bind:value={data.newData[input.field_name]}
								on:input={(e) => {
									phoneInputHandler(input, e.target.value);
									if (!noNeedToChange)
										$isNewDataChanged = true;
									if (e.target.value.length > 17)
										e.target.classList.remove("invalid");
									if (e.target.value[0] == "8") {
										e.target.pattern = ".{17,}";
									} else if (e.target.value[0] == "+") {
										e.target.pattern = ".{18,}";
									}
								}}
								pattern={".{18,}"}
								maxlength={input.maxlength
									? input.maxlength
									: 100}
							/>

							<span
								class={data.newData[input.field_name]
									? "active"
									: ""}>{input.description}</span
							>
						</div>
					{/if}
					{#if input.help}
						<div class="inputs__input-help">
							<i
								class="far fa-question-circle"
								on:mouseover={(e) => tooltip.create(e)}
								on:focus={(e) => tooltip.create(e)}
								on:mouseout={() => tooltip.delete()}
								on:blur={() => tooltip.delete()}
								data-tooltip={input.help}
							/>
							<div>{input.help}</div>
						</div>
					{/if}
				</div>
			{/each}
		{/if}
	</div>
{/if}

<style lang="scss">
	.inputs {
		display: flex;
		flex-direction: column;
		max-width: var(--module-width-1);
		position: relative;
		margin-top: 4px;

		&__item {
			display: flex;
			flex-direction: column;
			margin: 0 0 16px 0;
			position: relative;
			justify-content: center;

			&:last-child {
				margin: 0;
			}
		}

		&__input {
			display: flex;
			flex-direction: column;

			&-help {
				@media (min-width: 992px) {
					position: absolute;
					right: 16px;

					> div {
						display: none;
					}
				}

				> i {
					display: flex;
					font-size: 18px;
					font-weight: 100;
					color: var(--color-1);

					@media (max-width: 991px) {
						display: none;
					}
				}

				> div {
					color: var(--border-gray-1);
					font-size: 13px;
					line-height: 20px;
					margin: 6px 0 0 0;
				}
			}
		}
	}
</style>
